import Vue from 'vue'
import App from './App.vue'
import '@/styles/index.scss'

import store from '@/store'
import router from '@/router/index'

import ElementUI from 'element-ui'
import './styles/element-variables.scss'

import './permission' // permission control

Vue.use(ElementUI)

Vue.config.productionTip = false

window.vm = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
